const styles = {
  container: '',

  list: 'grid grid-cols-3 sm:grid-cols-3 gap-1 sm:gap-1',

  images: {
    container: 'grid grid-cols-3 gap-6',
    item: 'relative aspect-square w-full group overflow-hidden cursor-pointer',
    image:
      'object-cover group-hover:scale-105 transition-all duration-300 cursor-pointer',
  },
};

export default styles;
